export default __webpack_public_path__ + "static/media/civics-bg-small.a1ef2965.webp";